// @flow

import React, { useEffect, useState } from "react";
import classNames from "classnames";

type Props = $Exact<{
  title: string,
  children: React$Node,
  className?: string,
  titleClassName?: string,
  onClose: Function,
}>;

const RightPanel = ({ onClose, className, titleClassName, title, children }: Props) => {
  const [hasOpened, setHasOpened] = useState(false);

  useEffect(() => {
    const openTimeout = setTimeout(() => setHasOpened(true), 10); // small delay for transition to work

    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        closePanel();
      }
    };
    document.addEventListener("keyup", handleEsc);

    return () => {
      clearTimeout(openTimeout);
      document.removeEventListener("keyup", handleEsc);
    };
  }, []);

  const closePanel = () => {
    setHasOpened(false);
    setTimeout(() => onClose(), 300); // small delay for transition to work
  };

  return (
    <>
      <div className="panel-overlay" onClick={closePanel}></div>
      <div
        className={classNames("right-panelll", className, {
          ["open"]: hasOpened,
        })}
      >
        <div className="d-flex justify-content-between align-items-center mb-2 border-bottom-color-dark-grey">
          <h3 className={titleClassName}>{title}</h3>
          <span onClick={closePanel} className="material-icons fs-30 pointer">
            last_page
          </span>
        </div>
        {children}
      </div>
    </>
  );
};

export default RightPanel;
